import { createSlice } from "@reduxjs/toolkit";
const initialState = {user:{}, theme:'',isLoading:false};
const userContextSlice = createSlice({
    name:'userContext',
    initialState,
    reducers:{
        setUser(state, action){
            state.user = action.payload;
        },
        setTheme(state, action){
            state.theme = action.payload.theme;
        },
        loadingOn(state){
            state.isLoading=true;
        },
        loadingOff(state){
            state.isLoading=false;
        }

    }
});

export const userContextAction = userContextSlice.actions;
export default userContextSlice;